<sh-control *ngIf="control" [control]="this">
  <ng-container *ngIf="control; else templateInput">
    <input
      #inputRef
      (blur)="onTouchedCb?.()"
      (input)="emitOnChange(inputRef.value)"
      [attr.aria-invalid]="showError()"
      [class.p-invalid]="showError()"
      [disabled]="disabled"
      [formControl]="control"
      [placeholder]="placeholder"
      pInputText
      class="w-100"
    />
  </ng-container>

  <ng-template #templateInput>
    <input
      [(ngModel)]="value"
      (blur)="onTouchedCb?.()"
      (ngModelChange)="emitOnChange($event)"
      [attr.aria-invalid]="showError()"
      [class.p-invalid]="showError()"
      [disabled]="disabled"
      [placeholder]="placeholder"
      pInputText
      class="w-100"
    />
  </ng-template>
</sh-control>
